/* AXON Editorial Commerce V12. Shopify owns inventory, accounts and checkout. */
(() => {
  'use strict';
  if(typeof document==='undefined') return;
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');
  const $=(s,r=document)=>r.querySelector(s);
  const $$=(s,r=document)=>[...r.querySelectorAll(s)];
  const core=AXONVariantCore;
  const route=()=>window.Shopify?.routes?.root||'/';
  const focusables='a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  let activeDrawer=null,returnFocus=null;
  function openDrawer(el,overlay,trigger){
    if(!el)return;
    if(activeDrawer)closeDrawer(false);
    returnFocus=trigger||document.activeElement;
    activeDrawer={el,overlay};el.inert=false;el.classList.add('is-open');el.setAttribute('aria-hidden','false');overlay?.classList.add('is-open');document.body.classList.add('drawer-open');
    requestAnimationFrame(()=>$(focusables,el)?.focus());
  }
  function closeDrawer(restore=true){
    if(!activeDrawer)return;
    const {el,overlay}=activeDrawer;el.classList.remove('is-open');el.setAttribute('aria-hidden','true');el.inert=true;overlay?.classList.remove('is-open');document.body.classList.remove('drawer-open');activeDrawer=null;
    if(restore)returnFocus?.focus?.();returnFocus=null;
  }
  document.addEventListener('keydown',e=>{
    if(!activeDrawer)return;
    if(e.key==='Escape'){e.preventDefault();closeDrawer();return;}
    if(e.key!=='Tab')return;
    const items=$$(focusables,activeDrawer.el).filter(x=>!x.closest('[hidden]') && x.getClientRects().length);
    if(!items.length)return;
    if(e.shiftKey && document.activeElement===items[0]){e.preventDefault();items.at(-1).focus();}
    else if(!e.shiftKey && document.activeElement===items.at(-1)){e.preventDefault();items[0].focus();}
  });
  const cartDrawer=$('[data-cart-drawer]'),cartOverlay=$('[data-cart-overlay]');
  const quickDrawer=$('[data-axon-quickview]'),quickOverlay=$('[data-axon-quickview-overlay]');
  const filterDrawer=$('[data-filter-drawer]'),filterOverlay=$('[data-filter-overlay]');
  const cartContent=$('[data-axon-cart-content]');
  function setCartCount(cart){
    $$('[data-cart-open]').forEach(b=>{const count=$('[data-cart-count]',b);if(count)count.textContent=cart.item_count;else b.setAttribute('aria-label',`Open bag, ${cart.item_count} items`);});
  }
  function element(tag,cls,text){const el=document.createElement(tag);if(cls)el.className=cls;if(text!==undefined)el.textContent=text;return el;}
  async function refreshCart(){
    const r=await fetch(route()+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}});if(!r.ok)throw new Error('Unable to load bag');const cart=await r.json();setCartCount(cart);
    if(!cartContent)return cart;
    cartContent.replaceChildren();
    if(!cart.items.length){cartContent.append(element('p','', 'Your bag is empty.'));}
    for(const item of cart.items){
      const row=element('div','axon-cart-item');
      if(item.image){const img=element('img');img.src=item.image;img.alt=item.product_title||'';img.loading='lazy';row.append(img);}
      const info=element('div');info.append(element('strong','',item.product_title));
      if(item.variant_title && item.variant_title!=='Default Title')info.append(element('p','',item.variant_title));
      info.append(element('p','',`${item.quantity} × ${core.money(item.final_price,cart.money_format||'${'+'{amount}'+'}',cart.currency||'USD')}`));row.append(info);cartContent.append(row);
    }
    const total=element('p','axon-cart-total',`Subtotal · ${core.money(cart.total_price,'${'+'{amount}'+'}',cart.currency||'USD')}`);cartContent.append(total);
    return cart;
  }
  function openCart(trigger){openDrawer(cartDrawer,cartOverlay,trigger);refreshCart().catch(()=>{if(cartContent)cartContent.textContent='Unable to refresh the bag. Use View bag to continue.';});}
  document.addEventListener('click',e=>{
    const cartButton=e.target.closest('[data-cart-open]');if(cartButton){e.preventDefault();openCart(cartButton);}
    if(e.target.closest('[data-cart-close],[data-axon-quickview-close],[data-filter-close]'))closeDrawer();
    if(e.target===cartOverlay||e.target===quickOverlay||e.target===filterOverlay)closeDrawer();
    const filterButton=e.target.closest('[data-filter-open]');if(filterButton)openDrawer(filterDrawer,filterOverlay,filterButton);
  });
  const controllers=new WeakMap();
  function initProduct(root){
    if(controllers.has(root))return controllers.get(root);
    const json=$('[data-axon-product-json]',root);if(!json)return null;
    let data;try{data=JSON.parse(json.textContent);}catch(e){return null;}
    const form=$('[data-product-form]',root),select=$('select[name="id"]',form),price=$('[data-axon-price]',root),compare=$('[data-axon-compare]',root),add=$('[data-axon-add]',root),status=$('[data-axon-availability]',root),feedback=$('[data-axon-feedback]',root);
    if(!form||!select)return null;
    let current=data.variants.find(v=>String(v.id)===String(data.selectedVariantId))||data.variants.find(v=>v.available)||data.variants[0]||null;
    let selected=current?.options.slice()||data.options.map(o=>o.values[0]);
    let visibleMedia=[],activeMedia=null,pending=false;
    const thumbs=$$('[data-axon-thumb]',root),panes=$$('[data-axon-pane]',root);
    const mediaLinks=new Map(data.variantMedia.map(v=>[String(v.id),v.mediaId]));
    function showMedia(id){
      if(!visibleMedia.length)return;
      const chosen=visibleMedia.includes(String(id))?String(id):visibleMedia[0];activeMedia=chosen;
      for(const thumb of thumbs){const active=thumb.dataset.mediaId===chosen;thumb.classList.toggle('is-active',active);thumb.setAttribute('aria-pressed',String(active));}
      for(const pane of panes){const active=pane.dataset.mediaId===chosen;pane.hidden=!active;pane.classList.toggle('is-active',active);if(!active)$$('video',pane).forEach(v=>v.pause());}
      const count=$('[data-axon-media-count]',root);if(count)count.textContent=`${visibleMedia.indexOf(chosen)+1} / ${visibleMedia.length}`;
    }
    function syncGallery(preferred){
      let group=root.dataset.galleryFilter==='false'?{ids:data.media.map(m=>String(m.id)),preferred}:core.mediaForColor(data,selected[core.colorIndex(data.options)],preferred);
      visibleMedia=group.ids.map(String);
      for(const thumb of thumbs)thumb.hidden=!visibleMedia.includes(thumb.dataset.mediaId);
      for(const pane of panes)pane.hidden=!visibleMedia.includes(pane.dataset.mediaId);
      showMedia(group.preferred||visibleMedia[0]);
    }
    function sync(changed=-1,updateUrl=false){
      current=core.resolve(data.variants,selected,changed);
      if(current)selected=current.options.slice();
      for(const fieldset of $$('[data-axon-option]',root)){
        const index=Number(fieldset.dataset.optionIndex);const label=$('[data-axon-option-label]',fieldset);if(label)label.textContent=selected[index]||'';
        for(const button of $$('[data-axon-option-value]',fieldset)){
          const active=button.dataset.axonOptionValue===selected[index];const state=core.availability(data.variants,selected,index,button.dataset.axonOptionValue);
          button.classList.toggle('is-selected',active);button.classList.toggle('is-unavailable',!state.available);button.setAttribute('aria-pressed',String(active));button.title=state.available?'':state.exists?'Sold out in this combination':'Not available with other selected options';
        }
      }
      if(current){select.value=String(current.id);if(price)price.textContent=core.money(current.price,data.moneyFormat,data.currency);if(compare){compare.hidden=!(current.compare_at_price>current.price);compare.textContent=current.compare_at_price>current.price?core.money(current.compare_at_price,data.moneyFormat,data.currency):'';}}
      if(add){add.disabled=!current?.available||pending;add.textContent=current?.available?`ADD TO BAG · ${core.money(current.price,data.moneyFormat,data.currency)}`:current?'SOLD OUT':'UNAVAILABLE';}
      if(status)status.textContent=current?(current.available?'Available':'This combination is sold out.'):'This combination is unavailable.';
      syncGallery(current?mediaLinks.get(String(current.id)):null);
      if(updateUrl&&current&&!root.closest('[data-axon-quickview]')){const url=new URL(location.href);url.searchParams.set('variant',current.id);history.replaceState(history.state,'',url);}
    }
    for(const fieldset of $$('[data-axon-option]',root)){
      const index=Number(fieldset.dataset.optionIndex);
      fieldset.addEventListener('click',e=>{const button=e.target.closest('[data-axon-option-value]');if(!button)return;selected[index]=button.dataset.axonOptionValue;sync(index,true);});
    }
    select.addEventListener('change',()=>{const found=data.variants.find(v=>String(v.id)===select.value);if(found){selected=found.options.slice();sync(-1,true);}});
    for(const thumb of thumbs)thumb.addEventListener('click',()=>showMedia(thumb.dataset.mediaId));
    for(const [selector,offset] of [['[data-axon-gallery-prev]',-1],['[data-axon-gallery-next]',1]]){$(selector,root)?.addEventListener('click',()=>{if(!visibleMedia.length)return;showMedia(visibleMedia[(visibleMedia.indexOf(activeMedia)+offset+visibleMedia.length)%visibleMedia.length]);});}
    form.addEventListener('submit',async e=>{
      if(!current?.available||pending){e.preventDefault();return;}
      e.preventDefault();pending=true;add.disabled=true;add.textContent='ADDING…';if(feedback)feedback.textContent='';
      try{
        const body=new FormData(form);body.set('id',String(current.id));
        const r=await fetch(route()+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body});
        if(!r.ok){const error=await r.json().catch(()=>({}));throw new Error(error.description||error.message||'Unable to add this item.');}
        if(feedback)feedback.textContent='Added to bag.';
        pending=false;sync();
        const returnTo=root.closest('[data-axon-quickview]')?quickDrawer._returnTrigger:add;
        if(root.closest('[data-axon-quickview]'))closeDrawer(false);
        openCart(returnTo);
      }catch(error){if(feedback)feedback.textContent=error.message||'Unable to add item.';pending=false;sync();}
    });
    root.classList.add('is-enhanced');sync();
    const controller={sync,get variant(){return current;}};controllers.set(root,controller);return controller;
  }
  $$('[data-axon-product]').forEach(initProduct);
  let quickRequest=0;
  async function openQuickView(button){
    const url=new URL(button.dataset.productUrl,location.origin);
    if(url.origin!==location.origin||!url.pathname.includes('/products/'))return;
    const request=++quickRequest;
    quickDrawer._returnTrigger=button;
    const body=$('[data-axon-quickview-body]');if(!body)return location.assign(url.href);
    body.textContent='Loading product options…';openDrawer(quickDrawer,quickOverlay,button);
    try{
      url.searchParams.set('section_id','main-product');
      const r=await fetch(url,{credentials:'same-origin',headers:{Accept:'text/html'}});if(!r.ok)throw new Error();
      const html=await r.text();const doc=new DOMParser().parseFromString(html,'text/html');const product=$('[data-axon-product]',doc);if(!product)throw new Error();
      if(request!==quickRequest)return;
      body.replaceChildren(product);initProduct(product);
    }catch(error){if(request===quickRequest)location.assign(button.dataset.productUrl);}
  }
  document.addEventListener('click',e=>{const b=e.target.closest('[data-axon-quick-add]');if(b){e.preventDefault();openQuickView(b);}});
  // Keep the two-link header, white storefront and restrained morphic motion.
  if(document.body.classList.contains('morphic-motion')){
    const header=$('.site-header');let ticking=false;
    const update=()=>{header?.classList.toggle('is-scrolled',scrollY>18);ticking=false;};
    addEventListener('scroll',()=>{if(!ticking){requestAnimationFrame(update);ticking=true;}},{passive:true});update();
    if(!matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver'in window){
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('in-view');observer.unobserve(entry.target);}}),{threshold:.08});
      $$('.home-shop-nav__card,.editorial-panel,.section-head,.collection-heading').forEach(el=>{el.classList.add('morph-reveal');observer.observe(el);});
    }
  }
})();
